import { Outlet, useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import { LeftSidebar } from "./LeftSidebar";
import { TopNav } from "./TopNav";
import { MobileNav } from "./MobileNav";
import { DemoBanner } from "./DemoBanner";
import { DemoTour } from "@/components/DemoTour";
import { AskAria } from "@/components/aria/AskAria";

export const AppShell = () => {
  const { pathname } = useLocation();
  return (
    <div className="flex h-screen flex-col overflow-hidden bg-[#0A0A0A] pt-9 text-white">
      <DemoBanner />
      <LeftSidebar />
      <div className="flex min-h-0 flex-1 flex-col lg:pl-[248px]">
        <TopNav />
        <main className="min-h-0 flex-1 overflow-y-auto">
          <motion.div
            key={pathname}
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.28, ease: [0.22, 1, 0.36, 1] }}
            className={`mx-auto w-full max-w-[1600px] px-4 py-6 pb-28 sm:px-6 lg:px-8 lg:pb-6 ${
              pathname === "/expenses" ? "h-full" : ""
            }`}
          >
            <Outlet />
          </motion.div>
        </main>
      </div>
      <MobileNav />
      <AskAria />
      <DemoTour />
    </div>
  );
};
